import { format, uiStrings } from '@satu/shared'

const bulat = (n: number, cadangan: number): number =>
  Number.isFinite(n) ? Math.floor(n) : cadangan

/**
 * "Langkah 3 dari 7". The count follows the person's age while the birth date is typed, so
 * the step is clamped into it: never "Langkah 5 dari 4", never "Langkah 0".
 */
export function teksLangkahKe(langkah: number, jumlah: number): string {
  const total = Math.max(1, bulat(jumlah, 1))
  const ke = Math.min(Math.max(1, bulat(langkah, 1)), total)
  return format(uiStrings.wizard.langkahDari, { langkah: ke, jumlah: total })
}
